// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/api.js";
import ___CSS_LOADER_GET_URL_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/getUrl.js";
var ___CSS_LOADER_URL_IMPORT_0___ = new URL("data:image/svg+xml,%3csvg xmlns=%27http://www.w3.org/2000/svg%27 viewBox=%270 0 16 16%27%3e%3cpath fill=%27none%27 stroke=%27%231f5f5b%27 stroke-linecap=%27round%27 stroke-linejoin=%27round%27 stroke-width=%272%27 d=%27m2 5 6 6 6-6%27/%3e%3c/svg%3e", import.meta.url);
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
var ___CSS_LOADER_URL_REPLACEMENT_0___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_0___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.accounts-page {
  --acc-ink: #12211e;
  --acc-brand: #14524e;
  --acc-brand-deep: #0e3b38;
  --acc-soft: #e7f3f1;
  --acc-line: #dce6e2;
  --acc-muted: #5d726d;
  --acc-head: #f4f7f5;
  --acc-paper: #ffffff;
}

.accounts-form {
  background: var(--acc-paper, #fff);
  border: 1px solid var(--acc-line, #e6e8ee);
  border-radius: 12px;
  padding: 18px 18px 8px;
  margin-bottom: 16px;
  box-shadow: 0 1px 2px rgba(18, 33, 30, 0.04), 0 10px 28px rgba(18, 33, 30, 0.04);
}

.accounts-req {
  color: #c0392b;
}

.accounts-form .form-label {
  font-weight: 600;
  font-size: 13px;
  margin-bottom: 4px;
}

.accounts-form .form-control,
.accounts-form .form-select,
.accounts-filter .form-control,
.accounts-filter .form-select {
  width: 100%;
  min-height: 38px;
}

.accounts-preview {
  font-family: Consolas, "Courier New", monospace;
  background: #f8fafc;
  border: 1px dashed #9fb3c8;
  border-radius: 8px;
  padding: 12px;
  margin-bottom: 12px;
}

.accounts-error {
  background: #fff5f5;
  color: #9b1c1c;
  border: 1px solid #feb2b2;
  border-radius: 8px;
  padding: 8px 10px;
  margin-bottom: 12px;
}

.accounts-actions {
  display: flex;
  flex-wrap: wrap;
  gap: 8px;
  align-items: center;
  margin: 4px 0 16px;
}

.accounts-actions .btn {
  min-width: 120px;
}

.accounts-table-wrap {
  width: 100%;
  overflow-x: auto;
  margin-bottom: 16px;
  background: #fff;
  border: 1px solid var(--acc-line, #dce6e2);
  border-radius: 12px;
  box-shadow: 0 1px 2px rgba(18, 33, 30, 0.04), 0 10px 28px rgba(18, 33, 30, 0.04);
}

.accounts-panel .accounts-table-wrap,
.accounts-form .accounts-table-wrap {
  border: 0;
  box-shadow: none;
  border-radius: 8px;
  background: transparent;
  margin-bottom: 12px;
}

.accounts-table {
  width: 100%;
  min-width: 640px;
  border-collapse: collapse;
  background: #fff;
}

.accounts-table th,
.accounts-table td {
  border-bottom: 1px solid var(--acc-line, #e3ebe7);
  text-align: left;
  padding: 10px 12px;
  vertical-align: middle;
  background: transparent;
}

.accounts-table thead th {
  background: var(--acc-head, #f4f7f5);
  color: var(--acc-muted, #5d726d);
  font-size: 11px;
  font-weight: 700;
  letter-spacing: 0.04em;
  text-transform: uppercase;
  border-bottom-color: #cfdcd7;
}

.accounts-table tbody tr:hover td { background: #f7faf9; }

.accounts-table th.num,
.accounts-table td.num {
  text-align: right;
}

.accounts-table input {
  width: 120px;
  max-width: 100%;
}

@media (max-width: 767px) {
  .accounts-form {
    padding: 12px 12px 4px;
  }

  .accounts-actions {
    flex-direction: row;
    flex-wrap: wrap;
    align-items: center;
  }

  .accounts-actions .btn {
    width: auto;
  }
}

.accounts-next {
  display: flex;
  flex-direction: row;
  flex-wrap: wrap;
  align-items: center;
  gap: 8px;
  white-space: nowrap;
}
.accounts-table .accounts-actions {
  flex-direction: row;
  margin: 0;
}

.accounts-table .accounts-actions .accounts-icon-btn {
  min-width: 0;
  width: 32px;
}

.accounts-table .accounts-actions .btn {
  min-width: 0;
  width: auto;
}

.accounts-success {
  display: flex;
  flex-wrap: wrap;
  gap: 8px;
  align-items: center;
  background: #f0fff4;
  color: #276749;
  border: 1px solid #9ae6b4;
  border-radius: 8px;
  padding: 10px 12px;
  margin-bottom: 12px;
}

.accounts-entry {
  display: grid;
  gap: 20px;
  grid-template-columns: 1fr;
  align-items: stretch;
}

.accounts-panel {
  background: var(--acc-paper, #fff);
  border: 1px solid var(--acc-line, #e4ece8);
  border-radius: 12px;
  padding: 16px;
  margin-bottom: 16px;
  box-shadow: 0 1px 2px rgba(18, 33, 30, 0.04), 0 10px 28px rgba(18, 33, 30, 0.04);
}

.accounts-panel h3 {
  margin: 0 0 12px;
  font-size: 16px;
}

.accounts-entry-grid,
.accounts-filter-grid {
  display: grid;
  gap: 16px;
  grid-template-columns: 1fr;
}

.accounts-entry-grid label,
.accounts-filter-grid label,
.accounts-panel > label {
  display: flex;
  flex-direction: column;
  gap: 6px;
  font-size: 13px;
  font-weight: 600;
  margin: 0;
}

.accounts-span { grid-column: 1 / -1; }

.accounts-hint {
  font-weight: 400;
  color: #627d98;
  font-size: 12px;
}

.accounts-check {
  display: flex;
  align-items: center;
  gap: 8px;
  font-weight: 600;
  margin: 8px 0 12px;
}

.accounts-preview-row {
  display: grid;
  grid-template-columns: minmax(0, 1fr) 28px 110px 110px;
  gap: 8px;
  padding: 4px 0;
  border-bottom: 1px solid #edf2f7;
}

.accounts-preview-row.head,
.accounts-preview-row.total { font-weight: 600; }

.accounts-preview-row span:nth-child(3),
.accounts-preview-row span:nth-child(4) { text-align: right; }

.accounts-preview-row .indent { padding-left: 24px; }

.accounts-chip {
  display: inline-block;
  border: 1px solid #cbd5e0;
  border-radius: 999px;
  padding: 2px 8px;
  font-size: 12px;
}

.accounts-chip.ok { color: #276749; border-color: #9ae6b4; }
.accounts-chip.bad { color: #9b2c2c; border-color: #feb2b2; }
.accounts-chip.warn { color: #975a16; border-color: #f6e05e; }
.accounts-chip.info { color: #2a4365; border-color: #bee3f8; }
.accounts-chip.muted { color: #4a5568; border-color: #e2e8f0; }
.accounts-dim { opacity: 0.55; }
.accounts-money-neg { color: #9b2c2c; }
.accounts-note { border-radius: 10px; padding: 12px 14px; margin-bottom: 12px; }
.accounts-note.ok { background: #f0fff4; color: #276749; }
.accounts-note.warn { background: #fffaf0; color: #975a16; }
.accounts-credit-row { display: flex; justify-content: space-between; gap: 12px; padding: 3px 0; }
.accounts-progress { height: 6px; background: #e7f3f1; border-radius: 99px; margin: 8px 0; overflow: hidden; }
.accounts-progress span { display: block; height: 100%; }
.accounts-steps { display: flex; gap: 6px; flex-wrap: wrap; margin-top: 4px; font-size: 11px; color: var(--acc-muted, #5d726d); }
.accounts-steps .on { color: var(--acc-brand, #14524e); font-weight: 700; }
.accounts-steps .done { color: #276749; }
.accounts-modal.wide .accounts-panel { width: min(920px, 100%); }

.accounts-page { overflow-x: clip; }
.accounts-summary { display: grid; grid-template-columns: repeat(4, minmax(0, 1fr)); gap: 12px; margin-bottom: 16px; }
.accounts-summary div { background: #fff; border: 1px solid var(--acc-line, #dce6e2); border-radius: 12px; padding: 12px 14px; }
.accounts-summary span { display: block; color: var(--acc-muted, #5d726d); font-size: 12px; }
.accounts-summary strong { font-variant-numeric: tabular-nums; }
@media (max-width: 800px) { .accounts-summary { grid-template-columns: 1fr 1fr; } }
.accounts-page-head {
  display: flex;
  justify-content: space-between;
  align-items: flex-end;
  gap: 16px;
  margin-bottom: 16px;
}
.accounts-page-head .mainTitle { margin-bottom: 4px; }
.accounts-page-actions {
  display: flex;
  flex-direction: row;
  flex-wrap: wrap;
  gap: 10px;
  align-items: center;
  justify-content: flex-end;
}
.accounts-page .row {
  --bs-gutter-x: 16px !important;
  --bs-gutter-y: 16px !important;
}
.accounts-dialog {
  display: flex;
  flex-direction: column;
  align-items: stretch;
  width: min(720px, calc(100vw - 32px));
  max-height: 90vh;
  margin: 0;
  padding: 0;
  overflow: hidden;
}
.accounts-modal.wide .accounts-dialog { width: min(920px, calc(100vw - 32px)); }
.accounts-dialog-head,
.accounts-dialog-footer {
  display: flex;
  align-items: center;
  gap: 12px;
  padding: 14px 16px;
  background: #fff;
}
.accounts-dialog-head { justify-content: space-between; border-bottom: 1px solid var(--acc-line, #dce6e2); }
.accounts-dialog-head h3 { margin: 0; }
.accounts-dialog-x {
  border: 0;
  background: transparent;
  font-size: 24px;
  line-height: 1;
  width: 44px;
  height: 44px;
  color: var(--acc-ink, #12211e);
}
.accounts-dialog-body { overflow: auto; padding: 16px; }
.accounts-dialog-footer {
  justify-content: flex-end;
  flex-direction: row;
  flex-wrap: nowrap;
  width: 100%;
  gap: 12px;
  border-top: 1px solid var(--acc-line, #dce6e2);
  position: sticky;
  bottom: 0;
}
.accounts-dialog-footer .btn,
.accounts-form-actions .btn,
.accounts-page-actions .btn {
  display: inline-flex;
  align-items: center;
  justify-content: center;
  width: auto !important;
  min-width: 120px;
  min-height: 40px;
  flex: 0 0 auto;
  margin: 0;
  white-space: nowrap;
}
.accounts-page .accounts-dialog-footer .btn-outline-secondary,
.accounts-page .accounts-form-actions .btn-outline-secondary,
.accounts-page .accounts-page-actions .btn-outline-secondary {
  background: #fff !important;
  color: #12211e !important;
  border-color: #c5d0cc !important;
}
.accounts-page .accounts-dialog-footer .btn-primary,
.accounts-page .accounts-form-actions .btn-primary,
.accounts-page .accounts-form-actions .tally-btn,
.accounts-page .accounts-page-actions .btn-primary,
.accounts-page .accounts-toolbar .btn-primary {
  background: #14524e !important;
  border-color: #14524e !important;
  color: #fff !important;
}
.accounts-page .accounts-page-actions .btn-outline-primary,
.accounts-page .accounts-form-actions .btn-outline-primary {
  background: #fff !important;
  color: #14524e !important;
  border-color: #b7cdc8 !important;
}
.accounts-page .accounts-dialog-footer .btn-danger,
.accounts-page .accounts-form-actions .btn-danger {
  background: #9b2c2c !important;
  border-color: #9b2c2c !important;
  color: #fff !important;
}
.accounts-form-grid {
  display: grid;
  grid-template-columns: 1fr;
  gap: 16px;
  width: 100%;
}
.accounts-form-grid > * { min-width: 0; }
.accounts-form-grid .span-2 { grid-column: 1 / -1; }
.accounts-form-grid .accounts-check {
  display: flex;
  flex-direction: row;
  align-items: center;
  gap: 8px;
  min-height: 40px;
}
.accounts-line {
  display: grid;
  grid-template-columns: minmax(0, 2fr) minmax(80px, 1fr) minmax(80px, 1fr) minmax(90px, 1fr);
  gap: 16px;
  align-items: end;
  width: 100%;
}
.accounts-form-actions {
  display: flex;
  flex-direction: row;
  flex-wrap: wrap;
  justify-content: flex-end;
  align-items: center;
  gap: 12px;
  width: 100%;
  margin-top: 16px;
}
.accounts-form-actions.start { justify-content: flex-start; }
.accounts-form-actions.start,
.accounts-form-grid .accounts-form-actions { margin-top: 0; }
.accounts-dialog .accounts-entry { grid-template-columns: 1fr; }
@media (min-width: 900px) {
  .accounts-dialog .accounts-entry { grid-template-columns: minmax(0, 1.2fr) minmax(240px, 0.8fr); }
}
.accounts-dialog-note { margin: 0 0 12px; }
.accounts-pager-size { width: 90px; flex: 0 0 90px; }
@media (min-width: 700px) {
  .accounts-form-grid { grid-template-columns: 1fr 1fr; }
}
@media (max-width: 700px) {
  .accounts-line { grid-template-columns: 1fr 1fr; }
}
.accounts-panel > label.accounts-check,
.accounts-dialog .accounts-check {
  flex-direction: row;
  align-items: center;
  width: 100%;
}
.accounts-check input[type="checkbox"] {
  width: 18px;
  height: 18px;
  margin: 0;
  flex: 0 0 auto;
}
.accounts-table thead th { position: sticky; top: 0; z-index: 1; }
.accounts-table td { font-variant-numeric: tabular-nums; }

.accounts-modal {
  position: fixed;
  inset: 0;
  background: rgba(15, 23, 42, 0.45);
  display: flex;
  align-items: flex-start;
  justify-content: center;
  padding: 40px 16px;
  z-index: 1200;
  overflow: auto;
}

.accounts-modal .accounts-panel { width: min(720px, 100%); }

@media (max-width: 700px) {
  .accounts-page-head { flex-direction: column; align-items: stretch; }
  .accounts-modal { padding: 0; align-items: stretch; }
  .accounts-dialog { width: 100%; max-height: 100vh; height: 100%; border-radius: 0; }
  .accounts-page .btn { min-height: 44px; }
}

@media (min-width: 700px) {
  .accounts-entry-grid,
  .accounts-filter-grid { grid-template-columns: 1fr 1fr; }
}

@media (min-width: 1100px) {
  .accounts-entry { grid-template-columns: minmax(0, 1.15fr) minmax(320px, 0.85fr); }
  .accounts-filter-grid { grid-template-columns: repeat(3, minmax(0, 1fr)); }
}

.tally-field,
.accounts-entry-grid .tally-field,
.tally-filter .tally-field {
  display: flex;
  flex-direction: column;
  gap: 6px;
  font-size: 12px;
  font-weight: 600;
  color: #3d4f4d;
  position: relative;
}

.tally-field .form-control,
.tally-field .form-select,
.tally-combo .form-control,
.accounts-panel .form-control,
.accounts-panel .form-select {
  min-height: 40px;
  border: 1px solid #c5d0cc;
  border-radius: 6px;
  background-color: #fff;
  font-weight: 500;
  color: #1c2b29;
}

.tally-field .form-select,
.accounts-panel .form-select,
.accounts-filter .form-select,
.accounts-form .form-select {
  appearance: none;
  background-image: url(${___CSS_LOADER_URL_REPLACEMENT_0___});
  background-repeat: no-repeat;
  background-position: right 0.75rem center;
  background-size: 16px 12px;
  padding-right: 2.25rem;
}

.tally-field .form-control:focus,
.tally-field .form-select:focus,
.tally-combo .form-control:focus,
.accounts-panel .form-control:focus,
.accounts-panel .form-select:focus {
  border-color: var(--acc-brand, #14524e);
  box-shadow: 0 0 0 3px rgba(31, 95, 91, 0.15);
}

.tally-field:focus-within { z-index: 40; }
.tally-combo { position: relative; }
.tally-combo.open { z-index: 40; }
.tally-combo.invalid .form-control { border-color: #c0392b; }
.tally-combo .form-control {
  padding-right: 68px;
  overflow: hidden;
  text-overflow: ellipsis;
  white-space: nowrap;
}

.tally-combo-tools {
  position: absolute;
  right: 4px;
  top: 0;
  height: 40px;
  display: flex;
  align-items: center;
}

.tally-combo-tool {
  width: 28px;
  height: 28px;
  border: 0;
  background: transparent;
  color: #5c6f6c;
  border-radius: 4px;
}

.tally-combo-tool:hover { background: var(--acc-soft, #e7f3f1); color: var(--acc-brand, #14524e); }

.accounts-icon-btn {
  width: 32px;
  height: 32px;
  padding: 0;
  border: 0;
  background: transparent;
  color: #3d4f4d;
  border-radius: 6px;
  line-height: 1;
}

.accounts-icon-btn:hover { background: #e7f2f0; }
.accounts-icon-btn.danger { color: #c0392b; }
.accounts-icon-btn.danger:hover { background: #fdecec; }
.accounts-icon-btn:disabled { opacity: 0.35; cursor: not-allowed; }

.accounts-link {
  border: 0;
  background: transparent;
  box-shadow: none;
  padding: 0;
  color: var(--acc-brand, #14524e);
  font-weight: 600;
  text-decoration: none;
  cursor: pointer;
}

.accounts-link:hover,
.accounts-link:focus { text-decoration: none; color: var(--acc-brand-deep, #0e3b38); }

.accounts-voucher-link {
  display: inline-flex;
  align-items: center;
  gap: 6px;
  margin: 0;
  border: 0;
  outline: none;
  box-shadow: none;
  appearance: none;
  background: transparent;
  color: var(--acc-brand, #14524e);
  font-weight: 600;
  line-height: 1.3;
  padding: 4px 8px;
  border-radius: 6px;
  cursor: pointer;
  text-decoration: none;
  vertical-align: middle;
}

.accounts-voucher-link .bi {
  font-size: 13px;
  opacity: 0.45;
}

.accounts-voucher-link:hover {
  background: var(--acc-soft, #e7f3f1);
  color: var(--acc-brand-deep, #0e3b38);
  text-decoration: none;
}

.accounts-voucher-link:hover .bi { opacity: 1; }

.accounts-voucher-link:focus-visible {
  outline: 2px solid rgba(20, 82, 78, 0.35);
  outline-offset: 1px;
}

.tally-sheet-head {
  display: flex;
  align-items: flex-start;
  justify-content: space-between;
  gap: 12px;
  margin-bottom: 12px;
}

.tally-sheet-head h3,
.tally-sheet-head .accounts-hint { margin-bottom: 0; }

.tally-download { position: relative; flex: none; }

.tally-download-btn {
  width: 36px;
  height: 36px;
  display: inline-flex;
  align-items: center;
  justify-content: center;
  border: 1px solid #d5ddd9;
  border-radius: 8px;
  background: #fff;
  color: var(--acc-brand, #14524e);
  line-height: 1;
}

.tally-download-btn:hover,
.tally-download-btn[aria-expanded="true"] {
  background: #e7f2f0;
  border-color: var(--acc-brand, #14524e);
}

.tally-download-btn:disabled { opacity: 0.6; }

.tally-download-menu {
  position: absolute;
  top: calc(100% + 6px);
  right: 0;
  z-index: 6;
  min-width: 148px;
  padding: 6px;
  background: #fff;
  border: 1px solid #d5ddd9;
  border-radius: 10px;
  box-shadow: 0 8px 24px rgba(28, 43, 41, 0.12);
}

.tally-download-menu button {
  display: flex;
  align-items: center;
  gap: 8px;
  width: 100%;
  border: 0;
  border-radius: 8px;
  background: transparent;
  padding: 8px 10px;
  color: #1c2b29;
  font-weight: 600;
  text-align: left;
}

.tally-download-menu button:hover { background: #f4f7f6; }
.tally-download-menu .bi-file-earmark-excel { color: #1e7f4f; }
.tally-download-menu .bi-file-earmark-pdf { color: #c0392b; }

.tally-spin { display: inline-block; animation: tally-spin 0.8s linear infinite; }
@keyframes tally-spin { to { transform: rotate(360deg); } }

.accounts-page .btn-primary {
  background: var(--acc-brand, #14524e);
  border-color: var(--acc-brand, #14524e);
  border-radius: 8px;
  font-weight: 600;
  box-shadow: none;
}

.accounts-page .btn-primary:hover,
.accounts-page .btn-primary:focus {
  background: var(--acc-brand-deep, #0e3b38);
  border-color: var(--acc-brand-deep, #0e3b38);
}

.accounts-page .btn-outline-primary {
  color: var(--acc-brand, #14524e);
  border-color: #b7cdc8;
  border-radius: 8px;
  font-weight: 600;
  background: #fff;
}

.accounts-page .btn-outline-primary:hover,
.accounts-page .btn-outline-primary:focus {
  background: var(--acc-soft, #e7f3f1);
  color: var(--acc-brand-deep, #0e3b38);
  border-color: var(--acc-brand, #14524e);
}

.accounts-page .btn-outline-secondary {
  border-radius: 8px;
  border-color: var(--acc-line, #dce6e2);
  color: var(--acc-ink, #12211e);
}

.accounts-page .btn-link {
  color: var(--acc-brand, #14524e);
  text-decoration: none;
  font-weight: 600;
}

.accounts-page .btn-link:hover { color: var(--acc-brand-deep, #0e3b38); text-decoration: none; }

.accounts-actions .bi { margin-right: 6px; }

.tally-filter,
.accounts-panel:not(.accounts-dialog),
.accounts-form,
.accounts-entry,
.accounts-entry-grid,
.accounts-filter-grid,
.accounts-filter-bar {
  overflow: visible;
}
.tally-filter { position: relative; z-index: 30; }
.tally-sheet { position: relative; z-index: 1; }
.accounts-entry > .accounts-panel:first-child { position: relative; z-index: 2; }

.tally-combo-menu {
  position: absolute;
  top: calc(100% + 4px);
  left: 0;
  width: 100%;
  z-index: 50;
  max-height: 280px;
  overflow-x: hidden;
  overflow-y: auto;
  background: #fff;
  border: 1px solid #d5ddd9;
  border-radius: 8px;
  box-shadow: 0 12px 28px rgba(20, 40, 36, 0.14);
}
.tally-combo.drop-up .tally-combo-menu {
  top: auto;
  bottom: calc(100% + 4px);
}

.tally-combo-group {
  padding: 8px 12px 4px;
  font-size: 11px;
  letter-spacing: 0.02em;
  color: var(--acc-brand, #14524e);
  background: #f4f7f6;
}

.tally-combo-menu .tally-combo-option {
  display: block;
  width: 100%;
  height: auto;
  min-height: 36px;
  text-align: left;
  border: 0 !important;
  background: #fff !important;
  padding: 8px 12px;
  font-size: 14px;
  font-weight: 500;
  line-height: 1.35;
  color: #1c2b29 !important;
  white-space: nowrap;
  overflow: hidden;
  text-overflow: ellipsis;
  box-shadow: none !important;
}

.tally-combo-menu .tally-combo-option:hover,
.tally-combo-menu .tally-combo-option.active {
  background: #e7f2f0 !important;
  color: #1c2b29 !important;
}

.tally-combo-empty {
  padding: 12px;
  color: #627d98;
  font-size: 13px;
}

.tally-error { color: #c0392b; }

.tally-btn,
.accounts-actions .tally-btn {
  background: var(--acc-brand, #14524e);
  border-color: var(--acc-brand, #14524e);
  color: #fff;
  min-height: 40px;
  border-radius: 8px;
  font-weight: 600;
  padding-inline: 18px;
}

.tally-btn:hover,
.accounts-actions .tally-btn:hover { background: var(--acc-brand-deep, #0e3b38); color: #fff; }

.tally-btn:disabled { opacity: 0.65; }

.tally-filter {
  display: grid;
  grid-template-columns: 1fr;
  gap: 16px;
  align-items: end;
}

.tally-sheet h3 { margin-bottom: 2px; }

.tally-entry { min-width: 180px; }
.tally-entry-dr {
  display: flex;
  justify-content: space-between;
  gap: 16px;
  font-weight: 600;
}
.tally-entry-dr span:last-child { color: var(--acc-brand, #14524e); min-width: 22px; text-align: right; }
.tally-entry-to { padding-left: 28px; color: var(--acc-ink, #12211e); }
.tally-entry-narr { padding-left: 28px; color: var(--acc-muted, #5d726d); font-size: 12px; font-weight: 400; }
.tally-statement { font-variant-numeric: tabular-nums; }
.tally-statement thead th { background: var(--acc-head, #f4f7f5); color: var(--acc-muted, #5d726d); }
.tally-statement tfoot td { background: #f6f8f7; border-top: 1px solid #cfdcd7; font-weight: 600; }
.tally-statement tfoot tr:last-child td { background: var(--acc-soft, #e7f3f1); }

@media (min-width: 800px) {
  .tally-filter { grid-template-columns: minmax(220px, 2fr) 1fr 1fr auto; }
}

@media (max-width: 699px) {
  .accounts-preview-row { grid-template-columns: minmax(0, 1fr) 24px 72px 72px; font-size: 12px; }
  .tally-filter .tally-btn { width: 100%; }
  .accounts-cancel-actions .btn { flex: 1 1 140px; }
}

.accounts-page .row {
  --bs-gutter-x: 16px !important;
  --bs-gutter-y: 16px !important;
}

.accounts-page .form-label {
  margin-bottom: 6px;
  color: #3d4f4d;
  font-size: 12px;
  font-weight: 600;
}

.accounts-page .form-control,
.accounts-page .form-select {
  min-height: 40px;
  border: 1px solid #c5d0cc;
  border-radius: 8px;
  background-color: #fff;
  box-shadow: none;
}

.accounts-page .form-control:focus,
.accounts-page .form-select:focus {
  border-color: var(--acc-brand, #14524e);
  box-shadow: 0 0 0 3px rgba(20, 82, 78, 0.14);
}

.accounts-filter-bar {
  display: grid;
  grid-template-columns: 1fr;
  gap: 14px;
  align-items: end;
}

.accounts-toolbar {
  display: flex;
  flex-direction: row;
  flex-wrap: nowrap;
  gap: 10px;
  align-items: center;
}

.accounts-page .accounts-toolbar .btn {
  display: inline-flex;
  align-items: center;
  justify-content: center;
  width: auto;
  flex: 0 0 auto;
  min-height: 40px;
  margin: 0;
  border-radius: 8px;
  font-weight: 600;
  padding: 8px 16px;
  white-space: nowrap;
}

.accounts-page .accounts-toolbar .btn-outline-secondary {
  background: #fff !important;
  color: #12211e !important;
  border-color: #c5d0cc !important;
}

.accounts-page .accounts-toolbar .btn-outline-secondary:hover {
  background: #f4f7f5 !important;
  border-color: #14524e !important;
  color: #0e3b38 !important;
}

.accounts-page .accounts-toolbar .btn-primary {
  background: #14524e !important;
  border-color: #14524e !important;
  color: #fff !important;
}

.accounts-page .accounts-toolbar .btn-primary:hover {
  background: #0e3b38 !important;
  border-color: #0e3b38 !important;
  color: #fff !important;
}

@media (max-width: 899px) {
  .accounts-filter-bar .accounts-toolbar .btn { flex: 1 1; }
}

@media (min-width: 900px) {
  .accounts-filter-bar {
    grid-template-columns: minmax(180px, 1.5fr) minmax(150px, 1fr) minmax(120px, 0.8fr) auto;
  }
  .accounts-filter-bar.accounts-filter-compact {
    grid-template-columns: minmax(180px, 240px) auto;
  }
}

.accounts-entry > .accounts-panel {
  display: flex;
  flex-direction: column;
  margin-bottom: 0;
  height: 100%;
}

.accounts-entry .accounts-actions,
.accounts-entry > .accounts-panel > .accounts-form-actions {
  margin-top: auto;
  margin-bottom: 0;
  padding-top: 8px;
}

.accounts-facts {
  display: grid;
  grid-template-columns: 1fr;
  gap: 12px;
  margin-bottom: 16px;
}

.accounts-facts > div {
  display: flex;
  flex-direction: column;
  gap: 4px;
  padding: 12px 14px;
  background: var(--acc-head, #f4f7f5);
  border: 1px solid var(--acc-line, #dce6e2);
  border-radius: 10px;
}

.accounts-narration {
  display: flex;
  flex-direction: column;
  gap: 4px;
  margin: 12px 0 0;
}

.accounts-cancel {
  display: grid;
  gap: 14px;
  margin-top: 4px;
}

.accounts-cancel h3 { margin: 0; }

.accounts-cancel .accounts-hint { margin: 4px 0 0; }

.accounts-cancel-actions {
  display: flex;
  flex-wrap: wrap;
  gap: 10px;
  justify-content: flex-end;
  align-items: center;
}

.accounts-cancel-actions .btn {
  min-width: 148px;
  min-height: 40px;
  width: auto;
  border-radius: 8px;
  font-weight: 600;
}

.accounts-filter-grid > .btn {
  align-self: end;
  justify-self: start;
}

.accounts-page .btn-danger {
  background: #9b2c2c;
  border-color: #9b2c2c;
}

.accounts-page .btn-danger:hover:not(:disabled) {
  background: #7b2424;
  border-color: #7b2424;
}

.accounts-page .btn-outline-danger {
  border-radius: 8px;
  font-weight: 600;
}

@media (min-width: 700px) {
  .accounts-facts { grid-template-columns: 1fr 1fr; }
}
`, "",{"version":3,"sources":["webpack://./src/Pages/accounts/accounts.css"],"names":[],"mappings":"AAAA;EACE,kBAAkB;EAClB,oBAAoB;EACpB,yBAAyB;EACzB,mBAAmB;EACnB,mBAAmB;EACnB,oBAAoB;EACpB,mBAAmB;EACnB,oBAAoB;AACtB;;AAEA;EACE,kCAAkC;EAClC,0CAA0C;EAC1C,mBAAmB;EACnB,sBAAsB;EACtB,mBAAmB;EACnB,gFAAgF;AAClF;;AAEA;EACE,cAAc;AAChB;;AAEA;EACE,gBAAgB;EAChB,eAAe;EACf,kBAAkB;AACpB;;AAEA;;;;EAIE,WAAW;EACX,gBAAgB;AAClB;;AAEA;EACE,+CAA+C;EAC/C,mBAAmB;EACnB,0BAA0B;EAC1B,kBAAkB;EAClB,aAAa;EACb,mBAAmB;AACrB;;AAEA;EACE,mBAAmB;EACnB,cAAc;EACd,yBAAyB;EACzB,kBAAkB;EAClB,iBAAiB;EACjB,mBAAmB;AACrB;;AAEA;EACE,aAAa;EACb,eAAe;EACf,QAAQ;EACR,mBAAmB;EACnB,kBAAkB;AACpB;;AAEA;EACE,gBAAgB;AAClB;;AAEA;EACE,WAAW;EACX,gBAAgB;EAChB,mBAAmB;EACnB,gBAAgB;EAChB,0CAA0C;EAC1C,mBAAmB;EACnB,gFAAgF;AAClF;;AAEA;;EAEE,SAAS;EACT,gBAAgB;EAChB,kBAAkB;EAClB,uBAAuB;EACvB,mBAAmB;AACrB;;AAEA;EACE,WAAW;EACX,gBAAgB;EAChB,yBAAyB;EACzB,gBAAgB;AAClB;;AAEA;;EAEE,iDAAiD;EACjD,gBAAgB;EAChB,kBAAkB;EAClB,sBAAsB;EACtB,uBAAuB;AACzB;;AAEA;EACE,oCAAoC;EACpC,gCAAgC;EAChC,eAAe;EACf,gBAAgB;EAChB,sBAAsB;EACtB,yBAAyB;EACzB,4BAA4B;AAC9B;;AAEA,oCAAoC,mBAAmB,EAAE;;AAEzD;;EAEE,iBAAiB;AACnB;;AAEA;EACE,YAAY;EACZ,eAAe;AACjB;;AAEA;EACE;IACE,sBAAsB;EACxB;;EAEA;IACE,mBAAmB;IACnB,eAAe;IACf,mBAAmB;EACrB;;EAEA;IACE,WAAW;EACb;AACF;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,eAAe;EACf,mBAAmB;EACnB,QAAQ;EACR,mBAAmB;AACrB;AACA;EACE,mBAAmB;EACnB,SAAS;AACX;;AAEA;EACE,YAAY;EACZ,WAAW;AACb;;AAEA;EACE,YAAY;EACZ,WAAW;AACb;;AAEA;EACE,aAAa;EACb,eAAe;EACf,QAAQ;EACR,mBAAmB;EACnB,mBAAmB;EACnB,cAAc;EACd,yBAAyB;EACzB,kBAAkB;EAClB,kBAAkB;EAClB,mBAAmB;AACrB;;AAEA;EACE,aAAa;EACb,SAAS;EACT,0BAA0B;EAC1B,oBAAoB;AACtB;;AAEA;EACE,kCAAkC;EAClC,0CAA0C;EAC1C,mBAAmB;EACnB,aAAa;EACb,mBAAmB;EACnB,gFAAgF;AAClF;;AAEA;EACE,gBAAgB;EAChB,eAAe;AACjB;;AAEA;;EAEE,aAAa;EACb,SAAS;EACT,0BAA0B;AAC5B;;AAEA;;;EAGE,aAAa;EACb,sBAAsB;EACtB,QAAQ;EACR,eAAe;EACf,gBAAgB;EAChB,SAAS;AACX;;AAEA,iBAAiB,mBAAmB,EAAE;;AAEtC;EACE,gBAAgB;EAChB,cAAc;EACd,eAAe;AACjB;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,QAAQ;EACR,gBAAgB;EAChB,kBAAkB;AACpB;;AAEA;EACE,aAAa;EACb,sDAAsD;EACtD,QAAQ;EACR,cAAc;EACd,gCAAgC;AAClC;;AAEA;8BAC8B,gBAAgB,EAAE;;AAEhD;0CAC0C,iBAAiB,EAAE;;AAE7D,gCAAgC,kBAAkB,EAAE;;AAEpD;EACE,qBAAqB;EACrB,yBAAyB;EACzB,oBAAoB;EACpB,gBAAgB;EAChB,eAAe;AACjB;;AAEA,oBAAoB,cAAc,EAAE,qBAAqB,EAAE;AAC3D,qBAAqB,cAAc,EAAE,qBAAqB,EAAE;AAC5D,sBAAsB,cAAc,EAAE,qBAAqB,EAAE;AAC7D,sBAAsB,cAAc,EAAE,qBAAqB,EAAE;AAC7D,uBAAuB,cAAc,EAAE,qBAAqB,EAAE;AAC9D,gBAAgB,aAAa,EAAE;AAC/B,sBAAsB,cAAc,EAAE;AACtC,iBAAiB,mBAAmB,EAAE,kBAAkB,EAAE,mBAAmB,EAAE;AAC/E,oBAAoB,mBAAmB,EAAE,cAAc,EAAE;AACzD,sBAAsB,mBAAmB,EAAE,cAAc,EAAE;AAC3D,uBAAuB,aAAa,EAAE,8BAA8B,EAAE,SAAS,EAAE,cAAc,EAAE;AACjG,qBAAqB,WAAW,EAAE,mBAAmB,EAAE,mBAAmB,EAAE,aAAa,EAAE,gBAAgB,EAAE;AAC7G,0BAA0B,cAAc,EAAE,YAAY,EAAE;AACxD,kBAAkB,aAAa,EAAE,QAAQ,EAAE,eAAe,EAAE,eAAe,EAAE,eAAe,EAAE,gCAAgC,EAAE;AAChI,sBAAsB,gCAAgC,EAAE,gBAAgB,EAAE;AAC1E,wBAAwB,cAAc,EAAE;AACxC,uCAAuC,uBAAuB,EAAE;;AAEhE,iBAAiB,gBAAgB,EAAE;AACnC,oBAAoB,aAAa,EAAE,gDAAgD,EAAE,SAAS,EAAE,mBAAmB,EAAE;AACrH,wBAAwB,gBAAgB,EAAE,0CAA0C,EAAE,mBAAmB,EAAE,kBAAkB,EAAE;AAC/H,yBAAyB,cAAc,EAAE,gCAAgC,EAAE,eAAe,EAAE;AAC5F,2BAA2B,kCAAkC,EAAE;AAC/D,4BAA4B,oBAAoB,8BAA8B,EAAE,EAAE;AAClF;EACE,aAAa;EACb,8BAA8B;EAC9B,qBAAqB;EACrB,SAAS;EACT,mBAAmB;AACrB;AACA,iCAAiC,kBAAkB,EAAE;AACrD;EACE,aAAa;EACb,mBAAmB;EACnB,eAAe;EACf,SAAS;EACT,mBAAmB;EACnB,yBAAyB;AAC3B;AACA;EACE,8BAA8B;EAC9B,8BAA8B;AAChC;AACA;EACE,aAAa;EACb,sBAAsB;EACtB,oBAAoB;EACpB,qCAAqC;EACrC,gBAAgB;EAChB,SAAS;EACT,UAAU;EACV,gBAAgB;AAClB;AACA,wCAAwC,qCAAqC,EAAE;AAC/E;;EAEE,aAAa;EACb,mBAAmB;EACnB,SAAS;EACT,kBAAkB;EAClB,gBAAgB;AAClB;AACA,wBAAwB,8BAA8B,EAAE,iDAAiD,EAAE;AAC3G,2BAA2B,SAAS,EAAE;AACtC;EACE,SAAS;EACT,uBAAuB;EACvB,eAAe;EACf,cAAc;EACd,WAAW;EACX,YAAY;EACZ,8BAA8B;AAChC;AACA,wBAAwB,cAAc,EAAE,aAAa,EAAE;AACvD;EACE,yBAAyB;EACzB,mBAAmB;EACnB,iBAAiB;EACjB,WAAW;EACX,SAAS;EACT,8CAA8C;EAC9C,gBAAgB;EAChB,SAAS;AACX;AACA;;;EAGE,oBAAoB;EACpB,mBAAmB;EACnB,uBAAuB;EACvB,sBAAsB;EACtB,gBAAgB;EAChB,gBAAgB;EAChB,cAAc;EACd,SAAS;EACT,mBAAmB;AACrB;AACA;;;EAGE,2BAA2B;EAC3B,yBAAyB;EACzB,gCAAgC;AAClC;AACA;;;;;EAKE,8BAA8B;EAC9B,gCAAgC;EAChC,sBAAsB;AACxB;AACA;;EAEE,2BAA2B;EAC3B,yBAAyB;EACzB,gCAAgC;AAClC;AACA;;EAEE,8BAA8B;EAC9B,gCAAgC;EAChC,sBAAsB;AACxB;AACA;EACE,aAAa;EACb,0BAA0B;EAC1B,SAAS;EACT,WAAW;AACb;AACA,0BAA0B,YAAY,EAAE;AACxC,8BAA8B,mBAAmB,EAAE;AACnD;EACE,aAAa;EACb,mBAAmB;EACnB,mBAAmB;EACnB,QAAQ;EACR,gBAAgB;AAClB;AACA;EACE,aAAa;EACb,2FAA2F;EAC3F,SAAS;EACT,gBAAgB;EAChB,WAAW;AACb;AACA;EACE,aAAa;EACb,mBAAmB;EACnB,eAAe;EACf,yBAAyB;EACzB,mBAAmB;EACnB,SAAS;EACT,WAAW;EACX,gBAAgB;AAClB;AACA,+BAA+B,2BAA2B,EAAE;AAC5D;6CAC6C,aAAa,EAAE;AAC5D,mCAAmC,0BAA0B,EAAE;AAC/D;EACE,mCAAmC,4DAA4D,EAAE;AACnG;AACA,wBAAwB,gBAAgB,EAAE;AAC1C,uBAAuB,WAAW,EAAE,cAAc,EAAE;AACpD;EACE,sBAAsB,8BAA8B,EAAE;AACxD;AACA;EACE,iBAAiB,8BAA8B,EAAE;AACnD;AACA;;EAEE,mBAAmB;EACnB,mBAAmB;EACnB,WAAW;AACb;AACA;EACE,WAAW;EACX,YAAY;EACZ,SAAS;EACT,cAAc;AAChB;AACA,2BAA2B,gBAAgB,EAAE,MAAM,EAAE,UAAU,EAAE;AACjE,qBAAqB,kCAAkC,EAAE;;AAEzD;EACE,eAAe;EACf,QAAQ;EACR,kCAAkC;EAClC,aAAa;EACb,uBAAuB;EACvB,uBAAuB;EACvB,kBAAkB;EAClB,aAAa;EACb,cAAc;AAChB;;AAEA,kCAAkC,uBAAuB,EAAE;;AAE3D;EACE,sBAAsB,sBAAsB,EAAE,oBAAoB,EAAE;EACpE,kBAAkB,UAAU,EAAE,oBAAoB,EAAE;EACpD,mBAAmB,WAAW,EAAE,iBAAiB,EAAE,YAAY,EAAE,gBAAgB,EAAE;EACnF,sBAAsB,gBAAgB,EAAE;AAC1C;;AAEA;EACE;0BACwB,8BAA8B,EAAE;AAC1D;;AAEA;EACE,kBAAkB,8DAA8D,EAAE;EAClF,wBAAwB,gDAAgD,EAAE;AAC5E;;AAEA;;;EAGE,aAAa;EACb,sBAAsB;EACtB,QAAQ;EACR,eAAe;EACf,gBAAgB;EAChB,cAAc;EACd,kBAAkB;AACpB;;AAEA;;;;;EAKE,gBAAgB;EAChB,yBAAyB;EACzB,kBAAkB;EAClB,sBAAsB;EACtB,gBAAgB;EAChB,cAAc;AAChB;;AAEA;;;;EAIE,gBAAgB;EAChB,yDAAiP;EACjP,4BAA4B;EAC5B,yCAAyC;EACzC,0BAA0B;EAC1B,sBAAsB;AACxB;;AAEA;;;;;EAKE,uCAAuC;EACvC,4CAA4C;AAC9C;;AAEA,4BAA4B,WAAW,EAAE;AACzC,eAAe,kBAAkB,EAAE;AACnC,oBAAoB,WAAW,EAAE;AACjC,qCAAqC,qBAAqB,EAAE;AAC5D;EACE,mBAAmB;EACnB,gBAAgB;EAChB,uBAAuB;EACvB,mBAAmB;AACrB;;AAEA;EACE,kBAAkB;EAClB,UAAU;EACV,MAAM;EACN,YAAY;EACZ,aAAa;EACb,mBAAmB;AACrB;;AAEA;EACE,WAAW;EACX,YAAY;EACZ,SAAS;EACT,uBAAuB;EACvB,cAAc;EACd,kBAAkB;AACpB;;AAEA,0BAA0B,oCAAoC,EAAE,gCAAgC,EAAE;;AAElG;EACE,WAAW;EACX,YAAY;EACZ,UAAU;EACV,SAAS;EACT,uBAAuB;EACvB,cAAc;EACd,kBAAkB;EAClB,cAAc;AAChB;;AAEA,2BAA2B,mBAAmB,EAAE;AAChD,4BAA4B,cAAc,EAAE;AAC5C,kCAAkC,mBAAmB,EAAE;AACvD,8BAA8B,aAAa,EAAE,mBAAmB,EAAE;;AAElE;EACE,SAAS;EACT,uBAAuB;EACvB,gBAAgB;EAChB,UAAU;EACV,gCAAgC;EAChC,gBAAgB;EAChB,qBAAqB;EACrB,eAAe;AACjB;;AAEA;uBACuB,qBAAqB,EAAE,qCAAqC,EAAE;;AAErF;EACE,oBAAoB;EACpB,mBAAmB;EACnB,QAAQ;EACR,SAAS;EACT,SAAS;EACT,aAAa;EACb,gBAAgB;EAChB,gBAAgB;EAChB,uBAAuB;EACvB,gCAAgC;EAChC,gBAAgB;EAChB,gBAAgB;EAChB,gBAAgB;EAChB,kBAAkB;EAClB,eAAe;EACf,qBAAqB;EACrB,sBAAsB;AACxB;;AAEA;EACE,eAAe;EACf,aAAa;AACf;;AAEA;EACE,oCAAoC;EACpC,qCAAqC;EACrC,qBAAqB;AACvB;;AAEA,mCAAmC,UAAU,EAAE;;AAE/C;EACE,yCAAyC;EACzC,mBAAmB;AACrB;;AAEA;EACE,aAAa;EACb,uBAAuB;EACvB,8BAA8B;EAC9B,SAAS;EACT,mBAAmB;AACrB;;AAEA;mCACmC,gBAAgB,EAAE;;AAErD,kBAAkB,kBAAkB,EAAE,UAAU,EAAE;;AAElD;EACE,WAAW;EACX,YAAY;EACZ,oBAAoB;EACpB,mBAAmB;EACnB,uBAAuB;EACvB,yBAAyB;EACzB,kBAAkB;EAClB,gBAAgB;EAChB,gCAAgC;EAChC,cAAc;AAChB;;AAEA;;EAEE,mBAAmB;EACnB,uCAAuC;AACzC;;AAEA,+BAA+B,YAAY,EAAE;;AAE7C;EACE,kBAAkB;EAClB,qBAAqB;EACrB,QAAQ;EACR,UAAU;EACV,gBAAgB;EAChB,YAAY;EACZ,gBAAgB;EAChB,yBAAyB;EACzB,mBAAmB;EACnB,6CAA6C;AAC/C;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,QAAQ;EACR,WAAW;EACX,SAAS;EACT,kBAAkB;EAClB,uBAAuB;EACvB,iBAAiB;EACjB,cAAc;EACd,gBAAgB;EAChB,gBAAgB;AAClB;;AAEA,oCAAoC,mBAAmB,EAAE;AACzD,8CAA8C,cAAc,EAAE;AAC9D,4CAA4C,cAAc,EAAE;;AAE5D,cAAc,qBAAqB,EAAE,0CAA0C,EAAE;AACjF,wBAAwB,KAAK,yBAAyB,EAAE,EAAE;;AAE1D;EACE,qCAAqC;EACrC,uCAAuC;EACvC,kBAAkB;EAClB,gBAAgB;EAChB,gBAAgB;AAClB;;AAEA;;EAEE,0CAA0C;EAC1C,4CAA4C;AAC9C;;AAEA;EACE,gCAAgC;EAChC,qBAAqB;EACrB,kBAAkB;EAClB,gBAAgB;EAChB,gBAAgB;AAClB;;AAEA;;EAEE,oCAAoC;EACpC,qCAAqC;EACrC,uCAAuC;AACzC;;AAEA;EACE,kBAAkB;EAClB,sCAAsC;EACtC,8BAA8B;AAChC;;AAEA;EACE,gCAAgC;EAChC,qBAAqB;EACrB,gBAAgB;AAClB;;AAEA,iCAAiC,qCAAqC,EAAE,qBAAqB,EAAE;;AAE/F,wBAAwB,iBAAiB,EAAE;;AAE3C;;;;;;;EAOE,iBAAiB;AACnB;AACA,gBAAgB,kBAAkB,EAAE,WAAW,EAAE;AACjD,eAAe,kBAAkB,EAAE,UAAU,EAAE;AAC/C,gDAAgD,kBAAkB,EAAE,UAAU,EAAE;;AAEhF;EACE,kBAAkB;EAClB,qBAAqB;EACrB,OAAO;EACP,WAAW;EACX,WAAW;EACX,iBAAiB;EACjB,kBAAkB;EAClB,gBAAgB;EAChB,gBAAgB;EAChB,yBAAyB;EACzB,kBAAkB;EAClB,8CAA8C;AAChD;AACA;EACE,SAAS;EACT,wBAAwB;AAC1B;;AAEA;EACE,qBAAqB;EACrB,eAAe;EACf,sBAAsB;EACtB,gCAAgC;EAChC,mBAAmB;AACrB;;AAEA;EACE,cAAc;EACd,WAAW;EACX,YAAY;EACZ,gBAAgB;EAChB,gBAAgB;EAChB,oBAAoB;EACpB,2BAA2B;EAC3B,iBAAiB;EACjB,eAAe;EACf,gBAAgB;EAChB,iBAAiB;EACjB,yBAAyB;EACzB,mBAAmB;EACnB,gBAAgB;EAChB,uBAAuB;EACvB,2BAA2B;AAC7B;;AAEA;;EAEE,8BAA8B;EAC9B,yBAAyB;AAC3B;;AAEA;EACE,aAAa;EACb,cAAc;EACd,eAAe;AACjB;;AAEA,eAAe,cAAc,EAAE;;AAE/B;;EAEE,qCAAqC;EACrC,uCAAuC;EACvC,WAAW;EACX,gBAAgB;EAChB,kBAAkB;EAClB,gBAAgB;EAChB,oBAAoB;AACtB;;AAEA;qCACqC,0CAA0C,EAAE,WAAW,EAAE;;AAE9F,sBAAsB,aAAa,EAAE;;AAErC;EACE,aAAa;EACb,0BAA0B;EAC1B,SAAS;EACT,gBAAgB;AAClB;;AAEA,kBAAkB,kBAAkB,EAAE;;AAEtC,eAAe,gBAAgB,EAAE;AACjC;EACE,aAAa;EACb,8BAA8B;EAC9B,SAAS;EACT,gBAAgB;AAClB;AACA,kCAAkC,gCAAgC,EAAE,eAAe,EAAE,iBAAiB,EAAE;AACxG,kBAAkB,kBAAkB,EAAE,8BAA8B,EAAE;AACtE,oBAAoB,kBAAkB,EAAE,gCAAgC,EAAE,eAAe,EAAE,gBAAgB,EAAE;AAC7G,mBAAmB,kCAAkC,EAAE;AACvD,4BAA4B,oCAAoC,EAAE,gCAAgC,EAAE;AACpG,4BAA4B,mBAAmB,EAAE,6BAA6B,EAAE,gBAAgB,EAAE;AAClG,0CAA0C,oCAAoC,EAAE;;AAEhF;EACE,gBAAgB,sDAAsD,EAAE;AAC1E;;AAEA;EACE,wBAAwB,oDAAoD,EAAE,eAAe,EAAE;EAC/F,2BAA2B,WAAW,EAAE;EACxC,gCAAgC,eAAe,EAAE;AACnD;;AAEA;EACE,8BAA8B;EAC9B,8BAA8B;AAChC;;AAEA;EACE,kBAAkB;EAClB,cAAc;EACd,eAAe;EACf,gBAAgB;AAClB;;AAEA;;EAEE,gBAAgB;EAChB,yBAAyB;EACzB,kBAAkB;EAClB,sBAAsB;EACtB,gBAAgB;AAClB;;AAEA;;EAEE,uCAAuC;EACvC,4CAA4C;AAC9C;;AAEA;EACE,aAAa;EACb,0BAA0B;EAC1B,SAAS;EACT,gBAAgB;AAClB;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,iBAAiB;EACjB,SAAS;EACT,mBAAmB;AACrB;;AAEA;EACE,oBAAoB;EACpB,mBAAmB;EACnB,uBAAuB;EACvB,WAAW;EACX,cAAc;EACd,gBAAgB;EAChB,SAAS;EACT,kBAAkB;EAClB,gBAAgB;EAChB,iBAAiB;EACjB,mBAAmB;AACrB;;AAEA;EACE,2BAA2B;EAC3B,yBAAyB;EACzB,gCAAgC;AAClC;;AAEA;EACE,8BAA8B;EAC9B,gCAAgC;EAChC,yBAAyB;AAC3B;;AAEA;EACE,8BAA8B;EAC9B,gCAAgC;EAChC,sBAAsB;AACxB;;AAEA;EACE,8BAA8B;EAC9B,gCAAgC;EAChC,sBAAsB;AACxB;;AAEA;EACE,8CAA8C,SAAW,EAAE;AAC7D;;AAEA;EACE;IACE,wFAAwF;EAC1F;EACA;IACE,gDAAgD;EAClD;AACF;;AAEA;EACE,aAAa;EACb,sBAAsB;EACtB,gBAAgB;EAChB,YAAY;AACd;;AAEA;;EAEE,gBAAgB;EAChB,gBAAgB;EAChB,gBAAgB;AAClB;;AAEA;EACE,aAAa;EACb,0BAA0B;EAC1B,SAAS;EACT,mBAAmB;AACrB;;AAEA;EACE,aAAa;EACb,sBAAsB;EACtB,QAAQ;EACR,kBAAkB;EAClB,oCAAoC;EACpC,0CAA0C;EAC1C,mBAAmB;AACrB;;AAEA;EACE,aAAa;EACb,sBAAsB;EACtB,QAAQ;EACR,gBAAgB;AAClB;;AAEA;EACE,aAAa;EACb,SAAS;EACT,eAAe;AACjB;;AAEA,sBAAsB,SAAS,EAAE;;AAEjC,kCAAkC,eAAe,EAAE;;AAEnD;EACE,aAAa;EACb,eAAe;EACf,SAAS;EACT,yBAAyB;EACzB,mBAAmB;AACrB;;AAEA;EACE,gBAAgB;EAChB,gBAAgB;EAChB,WAAW;EACX,kBAAkB;EAClB,gBAAgB;AAClB;;AAEA;EACE,eAAe;EACf,mBAAmB;AACrB;;AAEA;EACE,mBAAmB;EACnB,qBAAqB;AACvB;;AAEA;EACE,mBAAmB;EACnB,qBAAqB;AACvB;;AAEA;EACE,kBAAkB;EAClB,gBAAgB;AAClB;;AAEA;EACE,kBAAkB,8BAA8B,EAAE;AACpD","sourcesContent":[".accounts-page {\n  --acc-ink: #12211e;\n  --acc-brand: #14524e;\n  --acc-brand-deep: #0e3b38;\n  --acc-soft: #e7f3f1;\n  --acc-line: #dce6e2;\n  --acc-muted: #5d726d;\n  --acc-head: #f4f7f5;\n  --acc-paper: #ffffff;\n}\n\n.accounts-form {\n  background: var(--acc-paper, #fff);\n  border: 1px solid var(--acc-line, #e6e8ee);\n  border-radius: 12px;\n  padding: 18px 18px 8px;\n  margin-bottom: 16px;\n  box-shadow: 0 1px 2px rgba(18, 33, 30, 0.04), 0 10px 28px rgba(18, 33, 30, 0.04);\n}\n\n.accounts-req {\n  color: #c0392b;\n}\n\n.accounts-form .form-label {\n  font-weight: 600;\n  font-size: 13px;\n  margin-bottom: 4px;\n}\n\n.accounts-form .form-control,\n.accounts-form .form-select,\n.accounts-filter .form-control,\n.accounts-filter .form-select {\n  width: 100%;\n  min-height: 38px;\n}\n\n.accounts-preview {\n  font-family: Consolas, \"Courier New\", monospace;\n  background: #f8fafc;\n  border: 1px dashed #9fb3c8;\n  border-radius: 8px;\n  padding: 12px;\n  margin-bottom: 12px;\n}\n\n.accounts-error {\n  background: #fff5f5;\n  color: #9b1c1c;\n  border: 1px solid #feb2b2;\n  border-radius: 8px;\n  padding: 8px 10px;\n  margin-bottom: 12px;\n}\n\n.accounts-actions {\n  display: flex;\n  flex-wrap: wrap;\n  gap: 8px;\n  align-items: center;\n  margin: 4px 0 16px;\n}\n\n.accounts-actions .btn {\n  min-width: 120px;\n}\n\n.accounts-table-wrap {\n  width: 100%;\n  overflow-x: auto;\n  margin-bottom: 16px;\n  background: #fff;\n  border: 1px solid var(--acc-line, #dce6e2);\n  border-radius: 12px;\n  box-shadow: 0 1px 2px rgba(18, 33, 30, 0.04), 0 10px 28px rgba(18, 33, 30, 0.04);\n}\n\n.accounts-panel .accounts-table-wrap,\n.accounts-form .accounts-table-wrap {\n  border: 0;\n  box-shadow: none;\n  border-radius: 8px;\n  background: transparent;\n  margin-bottom: 12px;\n}\n\n.accounts-table {\n  width: 100%;\n  min-width: 640px;\n  border-collapse: collapse;\n  background: #fff;\n}\n\n.accounts-table th,\n.accounts-table td {\n  border-bottom: 1px solid var(--acc-line, #e3ebe7);\n  text-align: left;\n  padding: 10px 12px;\n  vertical-align: middle;\n  background: transparent;\n}\n\n.accounts-table thead th {\n  background: var(--acc-head, #f4f7f5);\n  color: var(--acc-muted, #5d726d);\n  font-size: 11px;\n  font-weight: 700;\n  letter-spacing: 0.04em;\n  text-transform: uppercase;\n  border-bottom-color: #cfdcd7;\n}\n\n.accounts-table tbody tr:hover td { background: #f7faf9; }\n\n.accounts-table th.num,\n.accounts-table td.num {\n  text-align: right;\n}\n\n.accounts-table input {\n  width: 120px;\n  max-width: 100%;\n}\n\n@media (max-width: 767px) {\n  .accounts-form {\n    padding: 12px 12px 4px;\n  }\n\n  .accounts-actions {\n    flex-direction: row;\n    flex-wrap: wrap;\n    align-items: center;\n  }\n\n  .accounts-actions .btn {\n    width: auto;\n  }\n}\n\n.accounts-next {\n  display: flex;\n  flex-direction: row;\n  flex-wrap: wrap;\n  align-items: center;\n  gap: 8px;\n  white-space: nowrap;\n}\n.accounts-table .accounts-actions {\n  flex-direction: row;\n  margin: 0;\n}\n\n.accounts-table .accounts-actions .accounts-icon-btn {\n  min-width: 0;\n  width: 32px;\n}\n\n.accounts-table .accounts-actions .btn {\n  min-width: 0;\n  width: auto;\n}\n\n.accounts-success {\n  display: flex;\n  flex-wrap: wrap;\n  gap: 8px;\n  align-items: center;\n  background: #f0fff4;\n  color: #276749;\n  border: 1px solid #9ae6b4;\n  border-radius: 8px;\n  padding: 10px 12px;\n  margin-bottom: 12px;\n}\n\n.accounts-entry {\n  display: grid;\n  gap: 20px;\n  grid-template-columns: 1fr;\n  align-items: stretch;\n}\n\n.accounts-panel {\n  background: var(--acc-paper, #fff);\n  border: 1px solid var(--acc-line, #e4ece8);\n  border-radius: 12px;\n  padding: 16px;\n  margin-bottom: 16px;\n  box-shadow: 0 1px 2px rgba(18, 33, 30, 0.04), 0 10px 28px rgba(18, 33, 30, 0.04);\n}\n\n.accounts-panel h3 {\n  margin: 0 0 12px;\n  font-size: 16px;\n}\n\n.accounts-entry-grid,\n.accounts-filter-grid {\n  display: grid;\n  gap: 16px;\n  grid-template-columns: 1fr;\n}\n\n.accounts-entry-grid label,\n.accounts-filter-grid label,\n.accounts-panel > label {\n  display: flex;\n  flex-direction: column;\n  gap: 6px;\n  font-size: 13px;\n  font-weight: 600;\n  margin: 0;\n}\n\n.accounts-span { grid-column: 1 / -1; }\n\n.accounts-hint {\n  font-weight: 400;\n  color: #627d98;\n  font-size: 12px;\n}\n\n.accounts-check {\n  display: flex;\n  align-items: center;\n  gap: 8px;\n  font-weight: 600;\n  margin: 8px 0 12px;\n}\n\n.accounts-preview-row {\n  display: grid;\n  grid-template-columns: minmax(0, 1fr) 28px 110px 110px;\n  gap: 8px;\n  padding: 4px 0;\n  border-bottom: 1px solid #edf2f7;\n}\n\n.accounts-preview-row.head,\n.accounts-preview-row.total { font-weight: 600; }\n\n.accounts-preview-row span:nth-child(3),\n.accounts-preview-row span:nth-child(4) { text-align: right; }\n\n.accounts-preview-row .indent { padding-left: 24px; }\n\n.accounts-chip {\n  display: inline-block;\n  border: 1px solid #cbd5e0;\n  border-radius: 999px;\n  padding: 2px 8px;\n  font-size: 12px;\n}\n\n.accounts-chip.ok { color: #276749; border-color: #9ae6b4; }\n.accounts-chip.bad { color: #9b2c2c; border-color: #feb2b2; }\n.accounts-chip.warn { color: #975a16; border-color: #f6e05e; }\n.accounts-chip.info { color: #2a4365; border-color: #bee3f8; }\n.accounts-chip.muted { color: #4a5568; border-color: #e2e8f0; }\n.accounts-dim { opacity: 0.55; }\n.accounts-money-neg { color: #9b2c2c; }\n.accounts-note { border-radius: 10px; padding: 12px 14px; margin-bottom: 12px; }\n.accounts-note.ok { background: #f0fff4; color: #276749; }\n.accounts-note.warn { background: #fffaf0; color: #975a16; }\n.accounts-credit-row { display: flex; justify-content: space-between; gap: 12px; padding: 3px 0; }\n.accounts-progress { height: 6px; background: #e7f3f1; border-radius: 99px; margin: 8px 0; overflow: hidden; }\n.accounts-progress span { display: block; height: 100%; }\n.accounts-steps { display: flex; gap: 6px; flex-wrap: wrap; margin-top: 4px; font-size: 11px; color: var(--acc-muted, #5d726d); }\n.accounts-steps .on { color: var(--acc-brand, #14524e); font-weight: 700; }\n.accounts-steps .done { color: #276749; }\n.accounts-modal.wide .accounts-panel { width: min(920px, 100%); }\n\n.accounts-page { overflow-x: clip; }\n.accounts-summary { display: grid; grid-template-columns: repeat(4, minmax(0, 1fr)); gap: 12px; margin-bottom: 16px; }\n.accounts-summary div { background: #fff; border: 1px solid var(--acc-line, #dce6e2); border-radius: 12px; padding: 12px 14px; }\n.accounts-summary span { display: block; color: var(--acc-muted, #5d726d); font-size: 12px; }\n.accounts-summary strong { font-variant-numeric: tabular-nums; }\n@media (max-width: 800px) { .accounts-summary { grid-template-columns: 1fr 1fr; } }\n.accounts-page-head {\n  display: flex;\n  justify-content: space-between;\n  align-items: flex-end;\n  gap: 16px;\n  margin-bottom: 16px;\n}\n.accounts-page-head .mainTitle { margin-bottom: 4px; }\n.accounts-page-actions {\n  display: flex;\n  flex-direction: row;\n  flex-wrap: wrap;\n  gap: 10px;\n  align-items: center;\n  justify-content: flex-end;\n}\n.accounts-page .row {\n  --bs-gutter-x: 16px !important;\n  --bs-gutter-y: 16px !important;\n}\n.accounts-dialog {\n  display: flex;\n  flex-direction: column;\n  align-items: stretch;\n  width: min(720px, calc(100vw - 32px));\n  max-height: 90vh;\n  margin: 0;\n  padding: 0;\n  overflow: hidden;\n}\n.accounts-modal.wide .accounts-dialog { width: min(920px, calc(100vw - 32px)); }\n.accounts-dialog-head,\n.accounts-dialog-footer {\n  display: flex;\n  align-items: center;\n  gap: 12px;\n  padding: 14px 16px;\n  background: #fff;\n}\n.accounts-dialog-head { justify-content: space-between; border-bottom: 1px solid var(--acc-line, #dce6e2); }\n.accounts-dialog-head h3 { margin: 0; }\n.accounts-dialog-x {\n  border: 0;\n  background: transparent;\n  font-size: 24px;\n  line-height: 1;\n  width: 44px;\n  height: 44px;\n  color: var(--acc-ink, #12211e);\n}\n.accounts-dialog-body { overflow: auto; padding: 16px; }\n.accounts-dialog-footer {\n  justify-content: flex-end;\n  flex-direction: row;\n  flex-wrap: nowrap;\n  width: 100%;\n  gap: 12px;\n  border-top: 1px solid var(--acc-line, #dce6e2);\n  position: sticky;\n  bottom: 0;\n}\n.accounts-dialog-footer .btn,\n.accounts-form-actions .btn,\n.accounts-page-actions .btn {\n  display: inline-flex;\n  align-items: center;\n  justify-content: center;\n  width: auto !important;\n  min-width: 120px;\n  min-height: 40px;\n  flex: 0 0 auto;\n  margin: 0;\n  white-space: nowrap;\n}\n.accounts-page .accounts-dialog-footer .btn-outline-secondary,\n.accounts-page .accounts-form-actions .btn-outline-secondary,\n.accounts-page .accounts-page-actions .btn-outline-secondary {\n  background: #fff !important;\n  color: #12211e !important;\n  border-color: #c5d0cc !important;\n}\n.accounts-page .accounts-dialog-footer .btn-primary,\n.accounts-page .accounts-form-actions .btn-primary,\n.accounts-page .accounts-form-actions .tally-btn,\n.accounts-page .accounts-page-actions .btn-primary,\n.accounts-page .accounts-toolbar .btn-primary {\n  background: #14524e !important;\n  border-color: #14524e !important;\n  color: #fff !important;\n}\n.accounts-page .accounts-page-actions .btn-outline-primary,\n.accounts-page .accounts-form-actions .btn-outline-primary {\n  background: #fff !important;\n  color: #14524e !important;\n  border-color: #b7cdc8 !important;\n}\n.accounts-page .accounts-dialog-footer .btn-danger,\n.accounts-page .accounts-form-actions .btn-danger {\n  background: #9b2c2c !important;\n  border-color: #9b2c2c !important;\n  color: #fff !important;\n}\n.accounts-form-grid {\n  display: grid;\n  grid-template-columns: 1fr;\n  gap: 16px;\n  width: 100%;\n}\n.accounts-form-grid > * { min-width: 0; }\n.accounts-form-grid .span-2 { grid-column: 1 / -1; }\n.accounts-form-grid .accounts-check {\n  display: flex;\n  flex-direction: row;\n  align-items: center;\n  gap: 8px;\n  min-height: 40px;\n}\n.accounts-line {\n  display: grid;\n  grid-template-columns: minmax(0, 2fr) minmax(80px, 1fr) minmax(80px, 1fr) minmax(90px, 1fr);\n  gap: 16px;\n  align-items: end;\n  width: 100%;\n}\n.accounts-form-actions {\n  display: flex;\n  flex-direction: row;\n  flex-wrap: wrap;\n  justify-content: flex-end;\n  align-items: center;\n  gap: 12px;\n  width: 100%;\n  margin-top: 16px;\n}\n.accounts-form-actions.start { justify-content: flex-start; }\n.accounts-form-actions.start,\n.accounts-form-grid .accounts-form-actions { margin-top: 0; }\n.accounts-dialog .accounts-entry { grid-template-columns: 1fr; }\n@media (min-width: 900px) {\n  .accounts-dialog .accounts-entry { grid-template-columns: minmax(0, 1.2fr) minmax(240px, 0.8fr); }\n}\n.accounts-dialog-note { margin: 0 0 12px; }\n.accounts-pager-size { width: 90px; flex: 0 0 90px; }\n@media (min-width: 700px) {\n  .accounts-form-grid { grid-template-columns: 1fr 1fr; }\n}\n@media (max-width: 700px) {\n  .accounts-line { grid-template-columns: 1fr 1fr; }\n}\n.accounts-panel > label.accounts-check,\n.accounts-dialog .accounts-check {\n  flex-direction: row;\n  align-items: center;\n  width: 100%;\n}\n.accounts-check input[type=\"checkbox\"] {\n  width: 18px;\n  height: 18px;\n  margin: 0;\n  flex: 0 0 auto;\n}\n.accounts-table thead th { position: sticky; top: 0; z-index: 1; }\n.accounts-table td { font-variant-numeric: tabular-nums; }\n\n.accounts-modal {\n  position: fixed;\n  inset: 0;\n  background: rgba(15, 23, 42, 0.45);\n  display: flex;\n  align-items: flex-start;\n  justify-content: center;\n  padding: 40px 16px;\n  z-index: 1200;\n  overflow: auto;\n}\n\n.accounts-modal .accounts-panel { width: min(720px, 100%); }\n\n@media (max-width: 700px) {\n  .accounts-page-head { flex-direction: column; align-items: stretch; }\n  .accounts-modal { padding: 0; align-items: stretch; }\n  .accounts-dialog { width: 100%; max-height: 100vh; height: 100%; border-radius: 0; }\n  .accounts-page .btn { min-height: 44px; }\n}\n\n@media (min-width: 700px) {\n  .accounts-entry-grid,\n  .accounts-filter-grid { grid-template-columns: 1fr 1fr; }\n}\n\n@media (min-width: 1100px) {\n  .accounts-entry { grid-template-columns: minmax(0, 1.15fr) minmax(320px, 0.85fr); }\n  .accounts-filter-grid { grid-template-columns: repeat(3, minmax(0, 1fr)); }\n}\n\n.tally-field,\n.accounts-entry-grid .tally-field,\n.tally-filter .tally-field {\n  display: flex;\n  flex-direction: column;\n  gap: 6px;\n  font-size: 12px;\n  font-weight: 600;\n  color: #3d4f4d;\n  position: relative;\n}\n\n.tally-field .form-control,\n.tally-field .form-select,\n.tally-combo .form-control,\n.accounts-panel .form-control,\n.accounts-panel .form-select {\n  min-height: 40px;\n  border: 1px solid #c5d0cc;\n  border-radius: 6px;\n  background-color: #fff;\n  font-weight: 500;\n  color: #1c2b29;\n}\n\n.tally-field .form-select,\n.accounts-panel .form-select,\n.accounts-filter .form-select,\n.accounts-form .form-select {\n  appearance: none;\n  background-image: url(\"data:image/svg+xml,%3csvg xmlns='http://www.w3.org/2000/svg' viewBox='0 0 16 16'%3e%3cpath fill='none' stroke='%231f5f5b' stroke-linecap='round' stroke-linejoin='round' stroke-width='2' d='m2 5 6 6 6-6'/%3e%3c/svg%3e\");\n  background-repeat: no-repeat;\n  background-position: right 0.75rem center;\n  background-size: 16px 12px;\n  padding-right: 2.25rem;\n}\n\n.tally-field .form-control:focus,\n.tally-field .form-select:focus,\n.tally-combo .form-control:focus,\n.accounts-panel .form-control:focus,\n.accounts-panel .form-select:focus {\n  border-color: var(--acc-brand, #14524e);\n  box-shadow: 0 0 0 3px rgba(31, 95, 91, 0.15);\n}\n\n.tally-field:focus-within { z-index: 40; }\n.tally-combo { position: relative; }\n.tally-combo.open { z-index: 40; }\n.tally-combo.invalid .form-control { border-color: #c0392b; }\n.tally-combo .form-control {\n  padding-right: 68px;\n  overflow: hidden;\n  text-overflow: ellipsis;\n  white-space: nowrap;\n}\n\n.tally-combo-tools {\n  position: absolute;\n  right: 4px;\n  top: 0;\n  height: 40px;\n  display: flex;\n  align-items: center;\n}\n\n.tally-combo-tool {\n  width: 28px;\n  height: 28px;\n  border: 0;\n  background: transparent;\n  color: #5c6f6c;\n  border-radius: 4px;\n}\n\n.tally-combo-tool:hover { background: var(--acc-soft, #e7f3f1); color: var(--acc-brand, #14524e); }\n\n.accounts-icon-btn {\n  width: 32px;\n  height: 32px;\n  padding: 0;\n  border: 0;\n  background: transparent;\n  color: #3d4f4d;\n  border-radius: 6px;\n  line-height: 1;\n}\n\n.accounts-icon-btn:hover { background: #e7f2f0; }\n.accounts-icon-btn.danger { color: #c0392b; }\n.accounts-icon-btn.danger:hover { background: #fdecec; }\n.accounts-icon-btn:disabled { opacity: 0.35; cursor: not-allowed; }\n\n.accounts-link {\n  border: 0;\n  background: transparent;\n  box-shadow: none;\n  padding: 0;\n  color: var(--acc-brand, #14524e);\n  font-weight: 600;\n  text-decoration: none;\n  cursor: pointer;\n}\n\n.accounts-link:hover,\n.accounts-link:focus { text-decoration: none; color: var(--acc-brand-deep, #0e3b38); }\n\n.accounts-voucher-link {\n  display: inline-flex;\n  align-items: center;\n  gap: 6px;\n  margin: 0;\n  border: 0;\n  outline: none;\n  box-shadow: none;\n  appearance: none;\n  background: transparent;\n  color: var(--acc-brand, #14524e);\n  font-weight: 600;\n  line-height: 1.3;\n  padding: 4px 8px;\n  border-radius: 6px;\n  cursor: pointer;\n  text-decoration: none;\n  vertical-align: middle;\n}\n\n.accounts-voucher-link .bi {\n  font-size: 13px;\n  opacity: 0.45;\n}\n\n.accounts-voucher-link:hover {\n  background: var(--acc-soft, #e7f3f1);\n  color: var(--acc-brand-deep, #0e3b38);\n  text-decoration: none;\n}\n\n.accounts-voucher-link:hover .bi { opacity: 1; }\n\n.accounts-voucher-link:focus-visible {\n  outline: 2px solid rgba(20, 82, 78, 0.35);\n  outline-offset: 1px;\n}\n\n.tally-sheet-head {\n  display: flex;\n  align-items: flex-start;\n  justify-content: space-between;\n  gap: 12px;\n  margin-bottom: 12px;\n}\n\n.tally-sheet-head h3,\n.tally-sheet-head .accounts-hint { margin-bottom: 0; }\n\n.tally-download { position: relative; flex: none; }\n\n.tally-download-btn {\n  width: 36px;\n  height: 36px;\n  display: inline-flex;\n  align-items: center;\n  justify-content: center;\n  border: 1px solid #d5ddd9;\n  border-radius: 8px;\n  background: #fff;\n  color: var(--acc-brand, #14524e);\n  line-height: 1;\n}\n\n.tally-download-btn:hover,\n.tally-download-btn[aria-expanded=\"true\"] {\n  background: #e7f2f0;\n  border-color: var(--acc-brand, #14524e);\n}\n\n.tally-download-btn:disabled { opacity: 0.6; }\n\n.tally-download-menu {\n  position: absolute;\n  top: calc(100% + 6px);\n  right: 0;\n  z-index: 6;\n  min-width: 148px;\n  padding: 6px;\n  background: #fff;\n  border: 1px solid #d5ddd9;\n  border-radius: 10px;\n  box-shadow: 0 8px 24px rgba(28, 43, 41, 0.12);\n}\n\n.tally-download-menu button {\n  display: flex;\n  align-items: center;\n  gap: 8px;\n  width: 100%;\n  border: 0;\n  border-radius: 8px;\n  background: transparent;\n  padding: 8px 10px;\n  color: #1c2b29;\n  font-weight: 600;\n  text-align: left;\n}\n\n.tally-download-menu button:hover { background: #f4f7f6; }\n.tally-download-menu .bi-file-earmark-excel { color: #1e7f4f; }\n.tally-download-menu .bi-file-earmark-pdf { color: #c0392b; }\n\n.tally-spin { display: inline-block; animation: tally-spin 0.8s linear infinite; }\n@keyframes tally-spin { to { transform: rotate(360deg); } }\n\n.accounts-page .btn-primary {\n  background: var(--acc-brand, #14524e);\n  border-color: var(--acc-brand, #14524e);\n  border-radius: 8px;\n  font-weight: 600;\n  box-shadow: none;\n}\n\n.accounts-page .btn-primary:hover,\n.accounts-page .btn-primary:focus {\n  background: var(--acc-brand-deep, #0e3b38);\n  border-color: var(--acc-brand-deep, #0e3b38);\n}\n\n.accounts-page .btn-outline-primary {\n  color: var(--acc-brand, #14524e);\n  border-color: #b7cdc8;\n  border-radius: 8px;\n  font-weight: 600;\n  background: #fff;\n}\n\n.accounts-page .btn-outline-primary:hover,\n.accounts-page .btn-outline-primary:focus {\n  background: var(--acc-soft, #e7f3f1);\n  color: var(--acc-brand-deep, #0e3b38);\n  border-color: var(--acc-brand, #14524e);\n}\n\n.accounts-page .btn-outline-secondary {\n  border-radius: 8px;\n  border-color: var(--acc-line, #dce6e2);\n  color: var(--acc-ink, #12211e);\n}\n\n.accounts-page .btn-link {\n  color: var(--acc-brand, #14524e);\n  text-decoration: none;\n  font-weight: 600;\n}\n\n.accounts-page .btn-link:hover { color: var(--acc-brand-deep, #0e3b38); text-decoration: none; }\n\n.accounts-actions .bi { margin-right: 6px; }\n\n.tally-filter,\n.accounts-panel:not(.accounts-dialog),\n.accounts-form,\n.accounts-entry,\n.accounts-entry-grid,\n.accounts-filter-grid,\n.accounts-filter-bar {\n  overflow: visible;\n}\n.tally-filter { position: relative; z-index: 30; }\n.tally-sheet { position: relative; z-index: 1; }\n.accounts-entry > .accounts-panel:first-child { position: relative; z-index: 2; }\n\n.tally-combo-menu {\n  position: absolute;\n  top: calc(100% + 4px);\n  left: 0;\n  width: 100%;\n  z-index: 50;\n  max-height: 280px;\n  overflow-x: hidden;\n  overflow-y: auto;\n  background: #fff;\n  border: 1px solid #d5ddd9;\n  border-radius: 8px;\n  box-shadow: 0 12px 28px rgba(20, 40, 36, 0.14);\n}\n.tally-combo.drop-up .tally-combo-menu {\n  top: auto;\n  bottom: calc(100% + 4px);\n}\n\n.tally-combo-group {\n  padding: 8px 12px 4px;\n  font-size: 11px;\n  letter-spacing: 0.02em;\n  color: var(--acc-brand, #14524e);\n  background: #f4f7f6;\n}\n\n.tally-combo-menu .tally-combo-option {\n  display: block;\n  width: 100%;\n  height: auto;\n  min-height: 36px;\n  text-align: left;\n  border: 0 !important;\n  background: #fff !important;\n  padding: 8px 12px;\n  font-size: 14px;\n  font-weight: 500;\n  line-height: 1.35;\n  color: #1c2b29 !important;\n  white-space: nowrap;\n  overflow: hidden;\n  text-overflow: ellipsis;\n  box-shadow: none !important;\n}\n\n.tally-combo-menu .tally-combo-option:hover,\n.tally-combo-menu .tally-combo-option.active {\n  background: #e7f2f0 !important;\n  color: #1c2b29 !important;\n}\n\n.tally-combo-empty {\n  padding: 12px;\n  color: #627d98;\n  font-size: 13px;\n}\n\n.tally-error { color: #c0392b; }\n\n.tally-btn,\n.accounts-actions .tally-btn {\n  background: var(--acc-brand, #14524e);\n  border-color: var(--acc-brand, #14524e);\n  color: #fff;\n  min-height: 40px;\n  border-radius: 8px;\n  font-weight: 600;\n  padding-inline: 18px;\n}\n\n.tally-btn:hover,\n.accounts-actions .tally-btn:hover { background: var(--acc-brand-deep, #0e3b38); color: #fff; }\n\n.tally-btn:disabled { opacity: 0.65; }\n\n.tally-filter {\n  display: grid;\n  grid-template-columns: 1fr;\n  gap: 16px;\n  align-items: end;\n}\n\n.tally-sheet h3 { margin-bottom: 2px; }\n\n.tally-entry { min-width: 180px; }\n.tally-entry-dr {\n  display: flex;\n  justify-content: space-between;\n  gap: 16px;\n  font-weight: 600;\n}\n.tally-entry-dr span:last-child { color: var(--acc-brand, #14524e); min-width: 22px; text-align: right; }\n.tally-entry-to { padding-left: 28px; color: var(--acc-ink, #12211e); }\n.tally-entry-narr { padding-left: 28px; color: var(--acc-muted, #5d726d); font-size: 12px; font-weight: 400; }\n.tally-statement { font-variant-numeric: tabular-nums; }\n.tally-statement thead th { background: var(--acc-head, #f4f7f5); color: var(--acc-muted, #5d726d); }\n.tally-statement tfoot td { background: #f6f8f7; border-top: 1px solid #cfdcd7; font-weight: 600; }\n.tally-statement tfoot tr:last-child td { background: var(--acc-soft, #e7f3f1); }\n\n@media (min-width: 800px) {\n  .tally-filter { grid-template-columns: minmax(220px, 2fr) 1fr 1fr auto; }\n}\n\n@media (max-width: 699px) {\n  .accounts-preview-row { grid-template-columns: minmax(0, 1fr) 24px 72px 72px; font-size: 12px; }\n  .tally-filter .tally-btn { width: 100%; }\n  .accounts-cancel-actions .btn { flex: 1 1 140px; }\n}\n\n.accounts-page .row {\n  --bs-gutter-x: 16px !important;\n  --bs-gutter-y: 16px !important;\n}\n\n.accounts-page .form-label {\n  margin-bottom: 6px;\n  color: #3d4f4d;\n  font-size: 12px;\n  font-weight: 600;\n}\n\n.accounts-page .form-control,\n.accounts-page .form-select {\n  min-height: 40px;\n  border: 1px solid #c5d0cc;\n  border-radius: 8px;\n  background-color: #fff;\n  box-shadow: none;\n}\n\n.accounts-page .form-control:focus,\n.accounts-page .form-select:focus {\n  border-color: var(--acc-brand, #14524e);\n  box-shadow: 0 0 0 3px rgba(20, 82, 78, 0.14);\n}\n\n.accounts-filter-bar {\n  display: grid;\n  grid-template-columns: 1fr;\n  gap: 14px;\n  align-items: end;\n}\n\n.accounts-toolbar {\n  display: flex;\n  flex-direction: row;\n  flex-wrap: nowrap;\n  gap: 10px;\n  align-items: center;\n}\n\n.accounts-page .accounts-toolbar .btn {\n  display: inline-flex;\n  align-items: center;\n  justify-content: center;\n  width: auto;\n  flex: 0 0 auto;\n  min-height: 40px;\n  margin: 0;\n  border-radius: 8px;\n  font-weight: 600;\n  padding: 8px 16px;\n  white-space: nowrap;\n}\n\n.accounts-page .accounts-toolbar .btn-outline-secondary {\n  background: #fff !important;\n  color: #12211e !important;\n  border-color: #c5d0cc !important;\n}\n\n.accounts-page .accounts-toolbar .btn-outline-secondary:hover {\n  background: #f4f7f5 !important;\n  border-color: #14524e !important;\n  color: #0e3b38 !important;\n}\n\n.accounts-page .accounts-toolbar .btn-primary {\n  background: #14524e !important;\n  border-color: #14524e !important;\n  color: #fff !important;\n}\n\n.accounts-page .accounts-toolbar .btn-primary:hover {\n  background: #0e3b38 !important;\n  border-color: #0e3b38 !important;\n  color: #fff !important;\n}\n\n@media (max-width: 899px) {\n  .accounts-filter-bar .accounts-toolbar .btn { flex: 1 1 0; }\n}\n\n@media (min-width: 900px) {\n  .accounts-filter-bar {\n    grid-template-columns: minmax(180px, 1.5fr) minmax(150px, 1fr) minmax(120px, 0.8fr) auto;\n  }\n  .accounts-filter-bar.accounts-filter-compact {\n    grid-template-columns: minmax(180px, 240px) auto;\n  }\n}\n\n.accounts-entry > .accounts-panel {\n  display: flex;\n  flex-direction: column;\n  margin-bottom: 0;\n  height: 100%;\n}\n\n.accounts-entry .accounts-actions,\n.accounts-entry > .accounts-panel > .accounts-form-actions {\n  margin-top: auto;\n  margin-bottom: 0;\n  padding-top: 8px;\n}\n\n.accounts-facts {\n  display: grid;\n  grid-template-columns: 1fr;\n  gap: 12px;\n  margin-bottom: 16px;\n}\n\n.accounts-facts > div {\n  display: flex;\n  flex-direction: column;\n  gap: 4px;\n  padding: 12px 14px;\n  background: var(--acc-head, #f4f7f5);\n  border: 1px solid var(--acc-line, #dce6e2);\n  border-radius: 10px;\n}\n\n.accounts-narration {\n  display: flex;\n  flex-direction: column;\n  gap: 4px;\n  margin: 12px 0 0;\n}\n\n.accounts-cancel {\n  display: grid;\n  gap: 14px;\n  margin-top: 4px;\n}\n\n.accounts-cancel h3 { margin: 0; }\n\n.accounts-cancel .accounts-hint { margin: 4px 0 0; }\n\n.accounts-cancel-actions {\n  display: flex;\n  flex-wrap: wrap;\n  gap: 10px;\n  justify-content: flex-end;\n  align-items: center;\n}\n\n.accounts-cancel-actions .btn {\n  min-width: 148px;\n  min-height: 40px;\n  width: auto;\n  border-radius: 8px;\n  font-weight: 600;\n}\n\n.accounts-filter-grid > .btn {\n  align-self: end;\n  justify-self: start;\n}\n\n.accounts-page .btn-danger {\n  background: #9b2c2c;\n  border-color: #9b2c2c;\n}\n\n.accounts-page .btn-danger:hover:not(:disabled) {\n  background: #7b2424;\n  border-color: #7b2424;\n}\n\n.accounts-page .btn-outline-danger {\n  border-radius: 8px;\n  font-weight: 600;\n}\n\n@media (min-width: 700px) {\n  .accounts-facts { grid-template-columns: 1fr 1fr; }\n}\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
